module.exports = __webpack_public_path__ + "img/DE02027.fa1f0586.png";